export default "__VITE_PUBLIC_ASSET__4a961fd7__"